import React from "react";
import {
  Header,
  Button,
  Segment,
  Message,
  Icon,
  Grid
} from "semantic-ui-react";
import { TableWithPagination } from "../../components/TableView/TableWithPagination";
import moment from "moment";
import { Trans } from "react-i18next";

function mapRooms(roomId, rooms) {
  const room = rooms.find(room => room.roomId === roomId) || {};
  return room.name;
}

export const CleaningListComponent = props => {
  const headers = [
    { label: props.t("cleaning:cleanerText"), key: "cleaner" },
    { label: props.t("cleaning:dateFromText"), key: "displayFrom" },
    { label: props.t("cleaning:dateToText"), key: "displayTo" },
    { label: props.t("cleaning:roomsText"), key: "displayRooms" }
  ];
  const data = props.cleaningList.map(cleaning => {
    const user =
      props.users.find(user => user.userId === cleaning.userId) || {};
    const cleanerName =
      user.firstname && user.surname
        ? `${user.firstname} ${user.surname}`
        : user.email || "DELETED_USER";
    return {
      ...cleaning,
      displayFrom: moment(cleaning.from).format("DD/MM/YYYY"),
      displayTo: moment(cleaning.to).format("DD/MM/YYYY"),
      cleaner: cleanerName,
      displayRooms: cleaning.rooms
        .map(room => mapRooms(room.roomId, props.rooms))
        .join(", ")
    };
  });
  return (
    <React.Fragment>
      {props.infoCleaningMessageVisible && (
        <Message
          info
          icon
          onDismiss={() => props.toggleMessage("infoCleaningMessage")}>
          <Icon name="help" />
          <Message.Content>
            <Message.Header>Info</Message.Header>
            <Trans i18nKey="cleaning:scheduleCleaningMessageText">
              Po kliknięciu <strong>Schedule cleaning</strong> możesz swobodnie
              planować sprzątanie, wybierać daty oraz dodawać pokoje do listy
              dla danego pracownika (metodą przeciągnij i upuść). Kiedy
              skończysz pracę, zapisz zmiany.
            </Trans>
          </Message.Content>
        </Message>
      )}
      <Grid columns="equal">
        <Grid.Column>
          <Header as="h1">{props.t("cleaning:cleaningListHeaderText")}</Header>
        </Grid.Column>
        <Grid.Column textAlign="right">
          {!props.infoCleaningMessageVisible && (
            <Button
              icon
              onClick={() => {
                props.toggleMessage("infoCleaningMessage");
              }}
              style={{ backgroundColor: "#5a697b" }}>
              <Icon name="help" style={{ color: "white" }} />
            </Button>
          )}
        </Grid.Column>
      </Grid>
      <Segment>
        {props.isAdmin && (
          <Button
            color="orange"
            onClick={() => {
              props.loadFresh();
              props.history.push("/cleaning/schedule");
            }}>
            {props.t("cleaning:scheduleCleaningButton")}
          </Button>
        )}

        <TableWithPagination
          headers={headers}
          data={data}
          showActionButtons={props.isAdmin}
          handleRemoveClick={({ _id }) => props.removeCleaning(_id)}
          handleEditClick={cleaning => {
            props.loadCleaning(cleaning);
            props.history.push("/cleaning/schedule");
          }}
        />
      </Segment>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/cleaning/CleaningList/CleaningListComponent.js